import * as React from "react";

import Flex from "@components/layout/flex";
import SquareImg from "@components/basics/artwork-img";
import Typography from "@components/basics/typography";
import styled from "styled-components";
import { getWidth } from "@components/styles";

export interface CoverInfoProps {
  className?: string;
  srcImg?: string;
  title: string;
  text?: string;
  smallImg?: boolean;
}

export const CoverInfo: React.FC<CoverInfoProps> = (props) => {
  return (
    <Flex className={props.className}>
      <SquareImg className="img" size={props.smallImg ? 38 : 46} srcImg={props.srcImg} />
      <div className="wrapper">
        <Typography className="title" type="title">
          {props.title}
        </Typography>
        {props.text ? (
          <Typography className="text" type="paragraph" weight="700">
            {props.text}
          </Typography>
        ) : null}
      </div>
    </Flex>
  );
};

export default styled(CoverInfo)`
  align-items: center;

  .img {
    margin-right: 30px;
  }

  .wrapper {
    // max-width: ${getWidth(3)};
    width: ${getWidth(9)};

    .title,
    .text {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .text {
      margin-top: 6px;
    }
  }
`;
